import { render, staticRenderFns } from "./defaultPage.vue?vue&type=template&id=be62a396&scoped=true&"
import script from "./defaultPage.vue?vue&type=script&lang=js&"
export * from "./defaultPage.vue?vue&type=script&lang=js&"
import style0 from "./defaultPage.vue?vue&type=style&index=0&id=be62a396&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be62a396",
  null
  
)

export default component.exports